// BEGIN CUSTOM EDIT: Stape DataLayer integration | Date: 2025-01-24 | What: Centralize datalayer events for cart discount and product views
(function () {
  // Guard
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];

  function push(payload) {
    try {
      window.dataLayer.push(payload);
    } catch (e) {}
  }

  // Listen to success
  document.addEventListener('cart:discount:success', function (e) {
    const d = e.detail || {};
    push({
      event: 'discount_apply',
      status: 'success',
      code: d.code || '',
      duration_ms: d.durationMs || 0,
      cart_total_price: d.cartTotalPrice,
      discount_amount_total: d.discountAmountTotal
    });
  });

  // Listen to error
  document.addEventListener('cart:discount:error', function (e) {
    const d = e.detail || {};
    push({
      event: 'discount_apply',
      status: 'error',
      code: d.code || '',
      duration_ms: d.durationMs || 0,
      reason: d.reason || 'unknown'
    });
  });

  // BEGIN CUSTOM EDIT: view_item_stape on product switch | Date: 2026-02-01 | What: Fire view_item_stape when variation switcher changes product

  // Helper: Get user_data from last dataLayer event that had it
  function getLastUserData() {
    for (let i = window.dataLayer.length - 1; i >= 0; i--) {
      if (window.dataLayer[i]?.user_data) {
        return window.dataLayer[i].user_data;
      }
    }
    // Return default structure if not found
    return {
      first_name: null,
      last_name: null,
      email: null,
      phone: null,
      city: null,
      country: null,
      zip: null,
      region: null,
      street: null,
      customer_id: null,
      shopify_client_id: null
    };
  }

  // Helper: Build cart_state from Shopify cart
  async function getCartState() {
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`);
      if (!response.ok) throw new Error('Cart fetch failed');
      const cart = await response.json();
      const currency = window.Shopify?.currency?.active || 'EUR';
      return {
        cart_id: cart.token || null,
        cart_quantity: cart.item_count || 0,
        cart_value: cart.total_price ? cart.total_price / 100 : 0,
        currency: currency,
        lines: (cart.items || []).map(item => ({
          item_id: String(item.product_id),
          item_variant: String(item.variant_id),
          quantity: item.quantity,
          price: item.price / 100
        }))
      };
    } catch (e) {
      return { cart_id: null, cart_quantity: 0, cart_value: 0, currency: undefined, lines: [] };
    }
  }

  document.addEventListener('product:switched', async function (e) {
    const product = e.detail?.product;
    if (!product) return;

    const selectedVariant = product.selected_variant
      || product.variants?.find(v => String(v.id) === String(product.selected_variant_id))
      || product.variants?.find(v => v.available)
      || product.variants?.[0];

    // Get product image URL
    const imageURL = product.featured_image
      ? product.featured_image.replace(/^https?:/, '')
      : (product.images?.[0] ? product.images[0].replace(/^https?:/, '') : '');

    // Get currency from Shopify global or default to EUR
    const currency = window.Shopify?.currency?.active || 'EUR';

    // Build price (Shopify returns price in cents)
    const price = selectedVariant?.price ? selectedVariant.price / 100 : (product.price ? product.price / 100 : 0);

    // Build ecommerce item
    // item_id uses variant ID (not SKU) to match Stape's expected format
    const item = {
      item_id: selectedVariant ? String(selectedVariant.id) : String(product.id),
      item_sku: selectedVariant?.sku || '',
      item_variant: selectedVariant ? String(selectedVariant.id) : '',
      item_name: product.title || '',
      variant_name: selectedVariant?.title || 'Default Title',
      item_category: product.type || '',
      price: price,
      item_brand: product.vendor || '',
      imageURL: imageURL,
      item_url: `/products/${product.handle}`,
      quantity: '1'
    };

    // Get user_data and cart_state
    const user_data = getLastUserData();
    const cart_state = await getCartState();

    // Push view_item_stape event
    push({
      event: 'view_item_stape',
      user_data: user_data,
      ecommerce: {
        value: String(price),
        currency: currency,
        items: [item]
      },
      cart_state: cart_state,
      actual_url: window.location.origin + `/products/${product.handle}`,
      ecomm_pagetype: 'product'
    });
  });
  // END CUSTOM EDIT

  // ============================================================
  //  BEGIN CUSTOM EDIT: GTM DataLayer Events | Date: 2026-02-02
  //  What: Comprehensive dataLayer events for GTM tracking
  // ============================================================

  // ----------------------------------------------------------
  // 1. FILTER APPLIED - Collection pages
  // ----------------------------------------------------------
  document.addEventListener('facet:update:complete', function(event) {
    if (!event.detail?.success) return;

    const section = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    const collectionContext = section?.querySelector('[data-collection-analytics-context]');
    const searchContext = section?.querySelector('[data-search-analytics-context]');
    let resultsCount;

    if (collectionContext?.hasAttribute('data-collection-analytics-products-count')) {
      resultsCount = Number(collectionContext.dataset.collectionAnalyticsProductsCount);
    } else if (searchContext?.hasAttribute('data-search-analytics-results-count')) {
      resultsCount = Number(searchContext.dataset.searchAnalyticsResultsCount);
    } else {
      return;
    }

    if (!Number.isFinite(resultsCount)) resultsCount = 0;

    new URL(window.location.href).searchParams.forEach(function(value, key) {
      if (key.startsWith('filter.')) {
        push({
          event: 'filter_applied',
          filter_type: key.split('.').pop(),
          filter_value: value,
          results_count: resultsCount
        });
      }
    });
  });

  // ----------------------------------------------------------
  // 2. SORT CHANGED - Collection/Search pages
  // ----------------------------------------------------------
  document.addEventListener('click', function(e) {
    const sortOption = e.target.closest('facet-sort-by .popover-listbox__option');
    if (sortOption) {
      const sortValue = sortOption.getAttribute('value');
      if (sortValue) {
        push({
          event: 'sort_changed',
          sort_option: sortValue
        });
      }
    }
  });

  // ----------------------------------------------------------
  // 3. VARIANT SELECTED - Product pages
  // ----------------------------------------------------------
  // Helper: Get untranslated option name from product JSON
  function getOriginalOptionName(optionPosition) {
    // Try ShopifyAnalytics (most reliable)
    const meta = window.ShopifyAnalytics?.meta?.product;
    if (meta?.options && meta.options[optionPosition - 1]) {
      return meta.options[optionPosition - 1].toLowerCase();
    }

    // Try product JSON in page
    const productJson = document.querySelector('[data-product-json], script[data-product]');
    if (productJson) {
      try {
        const product = JSON.parse(productJson.textContent);
        if (product.options && product.options[optionPosition - 1]) {
          return product.options[optionPosition - 1].toLowerCase();
        }
      } catch (e) {}
    }

    return null;
  }

  // Listen for option clicks (swatch, block, thumbnail)
  document.addEventListener('click', function(e) {
    // Check if clicked on a variant option (label with swatch/block class, or inside variant-picker)
    const clickedLabel = e.target.closest('.color-swatch, .block-swatch, .thumbnail-swatch, .variant-picker__option-values label');
    const clickedInput = e.target.closest('.variant-picker__option-values input');

    const option = clickedLabel || clickedInput;
    if (!option) return;

    const fieldset = option.closest('fieldset.variant-picker__option');
    if (!fieldset) return;

    // Get option position for untranslated name lookup
    const input = fieldset.querySelector('input[data-option-position]');
    const optionPosition = input ? parseInt(input.dataset.optionPosition) : null;

    // Try to get untranslated option name, fallback to translated
    const legend = fieldset.querySelector('legend');
    const translatedType = legend ? legend.textContent.replace(':', '').trim().toLowerCase() : 'variant';
    const variantType = (optionPosition && getOriginalOptionName(optionPosition)) || translatedType;

    // Find the label element (could be the clicked element or its associated label)
    let labelElement = clickedLabel;
    if (!labelElement && clickedInput) {
      const inputId = clickedInput.id;
      labelElement = inputId ? document.querySelector(`label[for="${inputId}"]`) : null;
    }

    let variantValue = null;

    if (labelElement) {
      // Priority 1: data-tooltip attribute (used by swatches)
      variantValue = labelElement.getAttribute('data-tooltip');

      // Priority 2: sr-only span inside label
      if (!variantValue) {
        const srOnly = labelElement.querySelector('.sr-only');
        if (srOnly) {
          variantValue = srOnly.textContent.trim();
        }
      }

      // Priority 3: Direct text content for block-style options
      if (!variantValue) {
        const textSpan = labelElement.querySelector('span:not(.sr-only):not(.block-swatch__color):not(.swatch-number-overlay)');
        if (textSpan) {
          variantValue = textSpan.textContent.trim();
        }
      }
    }

    // Final fallback
    if (!variantValue) {
      variantValue = 'Unknown';
    }

    // Debounce to avoid duplicate events
    clearTimeout(window._variantSelectTimeout);
    window._variantSelectTimeout = setTimeout(function() {
      push({
        event: 'variant_selected',
        variant_type: variantType,
        variant_value: variantValue
      });
    }, 100);
  });

  // ----------------------------------------------------------
  // 4. MENU CLICK - Navigation
  // ----------------------------------------------------------
  document.addEventListener('click', function(e) {
    // Main navigation links
    const mainNavLink = e.target.closest('.header__link-list a, .header__main-nav a');
    if (mainNavLink && !mainNavLink.closest('.dropdown-menu')) {
      push({
        event: 'menu_click',
        menu_item: mainNavLink.textContent.trim(),
        menu_level: 'main'
      });
      return;
    }

    // Submenu links
    const submenuLink = e.target.closest('.dropdown-menu a, .mega-menu a');
    if (submenuLink) {
      push({
        event: 'menu_click',
        menu_item: submenuLink.textContent.trim(),
        menu_level: 'submenu'
      });
      return;
    }

    // Mobile navigation links
    const mobileNavLink = e.target.closest('.navigation-drawer a, [id="header-sidebar-menu"] a');
    if (mobileNavLink) {
      push({
        event: 'menu_click',
        menu_item: mobileNavLink.textContent.trim(),
        menu_level: 'mobile'
      });
    }
  });

  // ----------------------------------------------------------
  // 5. FOOTER CLICK - Footer links
  // ----------------------------------------------------------
  document.addEventListener('click', function(e) {
    const footerLink = e.target.closest('footer a, .footer a');
    if (footerLink) {
      // Exclude social media (tracked separately)
      if (footerLink.closest('.social-media')) return;

      push({
        event: 'footer_click',
        link_text: footerLink.textContent.trim(),
        link_url: footerLink.getAttribute('href')
      });
    }
  });

  // ----------------------------------------------------------
  // 6. ACCORDION TOGGLE - Product FAQs, Info sections
  // ----------------------------------------------------------
  document.addEventListener('toggle', function(e) {
    const details = e.target;
    if (details.tagName === 'DETAILS') {
      const summary = details.querySelector('summary');
      const title = summary ? summary.textContent.trim() : 'Unknown';

      push({
        event: 'accordion_toggle',
        accordion_title: title,
        accordion_action: details.open ? 'open' : 'close'
      });
    }
  }, true);

  // Also handle custom accordion elements
  document.addEventListener('click', function(e) {
    const accordionTrigger = e.target.closest('[data-accordion-toggle], .accordion-button, .collapsible-toggle');
    if (accordionTrigger) {
      const accordion = accordionTrigger.closest('[data-accordion], .accordion, .collapsible');
      const isOpen = accordion ? accordion.classList.contains('is-open') || accordion.hasAttribute('open') : false;
      const title = accordionTrigger.textContent.trim();

      push({
        event: 'accordion_toggle',
        accordion_title: title,
        accordion_action: isOpen ? 'close' : 'open'
      });
    }
  });

  // ----------------------------------------------------------
  // 7. SOCIAL LINK CLICK - Social media icons
  // ----------------------------------------------------------
  document.addEventListener('click', function(e) {
    const socialLink = e.target.closest('.social-media a, a[href*="facebook.com"], a[href*="instagram.com"], a[href*="tiktok.com"], a[href*="twitter.com"], a[href*="youtube.com"], a[href*="pinterest.com"], a[href*="linkedin.com"], a[href*="snapchat.com"], a[href*="whatsapp.com"], a[href*="x.com"]');
    if (socialLink) {
      const href = socialLink.getAttribute('href') || '';
      let platform = 'other';

      if (href.includes('facebook.com')) platform = 'facebook';
      else if (href.includes('instagram.com')) platform = 'instagram';
      else if (href.includes('tiktok.com')) platform = 'tiktok';
      else if (href.includes('twitter.com') || href.includes('x.com')) platform = 'twitter';
      else if (href.includes('youtube.com')) platform = 'youtube';
      else if (href.includes('pinterest.com')) platform = 'pinterest';
      else if (href.includes('linkedin.com')) platform = 'linkedin';
      else if (href.includes('snapchat.com')) platform = 'snapchat';
      else if (href.includes('whatsapp.com')) platform = 'whatsapp';
      else if (href.includes('threads.net')) platform = 'threads';
      else if (href.includes('vimeo.com')) platform = 'vimeo';
      else if (href.includes('tumblr.com')) platform = 'tumblr';
      else if (href.includes('reddit.com')) platform = 'reddit';
      else if (href.includes('spotify.com')) platform = 'spotify';

      push({
        event: 'social_link_click',
        social_platform: platform
      });
    }
  });

  // ----------------------------------------------------------
  // 8. BREADCRUMB CLICK - Breadcrumb navigation
  // ----------------------------------------------------------
  document.addEventListener('click', function(e) {
    const breadcrumbLink = e.target.closest('.breadcrumbs a, nav[aria-label*="breadcrumb"] a, .breadcrumb a');
    if (breadcrumbLink) {
      push({
        event: 'breadcrumb_click',
        link_text: breadcrumbLink.textContent.trim(),
        link_url: breadcrumbLink.getAttribute('href')
      });
    }
  });

  // ----------------------------------------------------------
  // 9. TESTIMONIAL VIEW - Homepage testimonials
  // ----------------------------------------------------------
  (function() {
    const testimonialObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const testimonial = entry.target;
          const container = testimonial.closest('.testimonials, [class*="testimonial"], [class*="review"]');
          if (container) {
            const items = Array.from(container.querySelectorAll('.testimonial-item, .testimonial__item, [class*="testimonial-card"], .review-item'));
            const index = items.indexOf(testimonial) + 1;

            push({
              event: 'testimonial_view',
              testimonial_index: index || 1
            });
          } else {
            push({
              event: 'testimonial_view',
              testimonial_index: 1
            });
          }
          testimonialObserver.unobserve(testimonial);
        }
      });
    }, { threshold: 0.5 });

    // Observe testimonials when DOM is ready
    function observeTestimonials() {
      document.querySelectorAll('.testimonial-item, .testimonial__item, [class*="testimonial-card"], .review-item, .testimonials__slide').forEach(function(t) {
        testimonialObserver.observe(t);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeTestimonials);
    } else {
      observeTestimonials();
    }
  })();

  // ============================================================
  //  END CUSTOM EDIT: GTM DataLayer Events
  // ============================================================

  // ============================================================
  //  BEGIN CUSTOM EDIT: Product Page Tracking | Date: 2026-02-02
  //  What: Product page specific events (reviews, custom length, recommendations)
  // ============================================================

  // ----------------------------------------------------------
  // 11. REVIEWS CLICK - Star rating / review count link
  // ----------------------------------------------------------
  document.addEventListener('click', function(e) {
    const reviewLink = e.target.closest('a.rating, a[href*="review"], a[href*="Review"], [data-reviews-link], a[href="#reviewsiowidget"]');
    if (reviewLink) {
      // Try to get review count from various possible elements
      const countEl = reviewLink.querySelector('.text-sm, [data-review-count], .rating__count');
      let reviewCount = 0;

      if (countEl) {
        // Extract number from text like "2386" or "(2386)"
        const countText = countEl.textContent.replace(/[^\d]/g, '');
        reviewCount = parseInt(countText) || 0;
      }

      push({
        event: 'reviews_click',
        review_count: reviewCount
      });
    }
  });

  // ----------------------------------------------------------
  // 12. CUSTOM LENGTH ENTERED - Custom length input field
  // ----------------------------------------------------------
  (function() {
    function initCustomLengthTracking() {
      const customLengthInput = document.querySelector('input.custom-length-input, input[name*="Wunschlänge"], input[data-custom-length]');
      if (!customLengthInput || customLengthInput._dlTracked) return;

      customLengthInput._dlTracked = true;
      let debounceTimer;

      customLengthInput.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        const value = parseFloat(this.value);

        // Detect unit from the page (look for unit selector or text)
        const unitSelector = document.querySelector('[data-unit-selector], select[name*="unit"]');
        const unit = unitSelector ? unitSelector.value : 'cm';

        // Adjust validation range based on unit
        const minValue = unit === 'in' ? 6 : 15;
        const maxValue = unit === 'in' ? 71 : 180;

        if (value >= minValue && value <= maxValue) {
          debounceTimer = setTimeout(function() {
            push({
              event: 'custom_length_entered',
              custom_length_value: value,
              custom_length_unit: unit
            });
          }, 1000); // 1 second debounce
        }
      });

      // Also track on blur/change for immediate submission
      customLengthInput.addEventListener('change', function() {
        clearTimeout(debounceTimer);
        const value = parseFloat(this.value);

        // Detect unit from the page
        const unitSelector = document.querySelector('[data-unit-selector], select[name*="unit"]');
        const unit = unitSelector ? unitSelector.value : 'cm';

        // Adjust validation range based on unit
        const minValue = unit === 'in' ? 6 : 15;
        const maxValue = unit === 'in' ? 71 : 180;

        if (value >= minValue && value <= maxValue) {
          push({
            event: 'custom_length_entered',
            custom_length_value: value,
            custom_length_unit: unit
          });
        }
      });
    }

    // Init on load and observe for dynamically added inputs
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCustomLengthTracking);
    } else {
      initCustomLengthTracking();
    }

    // Re-init when variant changes (input might be re-rendered)
    document.addEventListener('variant:change', function() {
      setTimeout(initCustomLengthTracking, 100);
    });
  })();

  // ----------------------------------------------------------
  // 13. COMPLEMENTARY PRODUCT CLICK - Recommendations section
  // ----------------------------------------------------------
  document.addEventListener('click', function(e) {
    const productLink = e.target.closest('product-recommendations a[href*="/products/"], .product-recommendations a[href*="/products/"], [data-complementary-products] a[href*="/products/"]');
    if (!productLink) return;

    const productCard = productLink.closest('.product-card, [data-product-card], product-card');
    const recommendationsContainer = productLink.closest('product-recommendations, .product-recommendations, [data-complementary-products]');

    // Get product info
    const productName = productCard?.querySelector('.product-card__title, [data-product-title], .product-title')?.textContent?.trim() || '';
    let productId = productCard?.dataset?.productId;

    // Fallback: extract from URL
    if (!productId) {
      const urlMatch = productLink.href.match(/\/products\/([^/?]+)/);
      productId = urlMatch ? urlMatch[1] : '';
    }

    // Get source product ID
    const sourceProductId = recommendationsContainer?.getAttribute('product') ||
                           recommendationsContainer?.dataset?.productId ||
                           document.querySelector('[data-product-id]')?.dataset?.productId || '';

    // Calculate position
    let position = 1;
    if (recommendationsContainer) {
      const allProductLinks = recommendationsContainer.querySelectorAll('a[href*="/products/"]');
      position = Array.from(allProductLinks).indexOf(productLink) + 1;
    }

    push({
      event: 'complementary_product_click',
      recommended_product_id: productId,
      recommended_product_name: productName,
      source_product_id: sourceProductId,
      position: position
    });
  });

  // ----------------------------------------------------------
  // 14. RECOMMENDATION ADD TO CART - Add from recommendations
  // ----------------------------------------------------------
  (function() {
    function initRecommendationAddToCart() {
      document.querySelectorAll('product-recommendations form[is="product-form"]').forEach(function(form, index) {
        if (form._dlTracked) return;
        form._dlTracked = true;

        form.addEventListener('submit', function() {
          var productCard = this.closest('[class*="product-card"]')?.parentElement;
          var productName = productCard?.querySelector('[class*="title"]')?.textContent?.trim();
          var variantId = this.querySelector('input[name="id"]')?.value;
          var sourceProductId = document.querySelector('product-recommendations')?.getAttribute('product');

          push({
            event: 'recommendation_add_to_cart',
            recommended_product_id: variantId,
            recommended_product_name: productName || '',
            source_product_id: sourceProductId,
            position: index + 1
          });
        });
      });
    }

    // Init on load and after dynamic content loads
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRecommendationAddToCart);
    } else {
      initRecommendationAddToCart();
    }

    // Re-init when recommendations load (they're often lazy-loaded)
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          initRecommendationAddToCart();
        }
      });
    });

    const recommendationsContainer = document.querySelector('product-recommendations');
    if (recommendationsContainer) {
      observer.observe(recommendationsContainer, { childList: true, subtree: true });
    }
  })();

  // ----------------------------------------------------------
  // 15. COMPLEMENTARY CAROUSEL NAVIGATE - Prev/Next arrows
  // ----------------------------------------------------------
  document.addEventListener('click', function(e) {
    const carouselBtn = e.target.closest('product-recommendations [is="prev-button"], product-recommendations [is="next-button"], .product-recommendations .carousel-prev, .product-recommendations .carousel-next, [data-complementary-products] [is="prev-button"], [data-complementary-products] [is="next-button"]');
    if (!carouselBtn) return;

    const isNext = carouselBtn.matches('[is="next-button"], .carousel-next, [data-direction="next"]');
    const direction = isNext ? 'next' : 'prev';

    const recommendationsContainer = carouselBtn.closest('product-recommendations, .product-recommendations, [data-complementary-products]');
    const sourceProductId = recommendationsContainer?.getAttribute('product') ||
                           recommendationsContainer?.dataset?.productId ||
                           document.querySelector('[data-product-id]')?.dataset?.productId || '';

    push({
      event: 'complementary_carousel_navigate',
      direction: direction,
      source_product_id: sourceProductId
    });
  });

  // ============================================================
  //  END CUSTOM EDIT: Product Page Tracking
  // ============================================================

  // ============================================================
  //  BEGIN CUSTOM EDIT: Cart Drawer Recommendations Tracking | Date: 2026-02-05
  //  What: Track interactions with dynamic cart drawer recommendations
  // ============================================================

  // ----------------------------------------------------------
  // 16. CART DRAWER RECOMMENDATION CLICK - Product link click
  // ----------------------------------------------------------
  document.addEventListener('click', function(e) {
    const productLink = e.target.closest('#cart-drawer-recommendations-container a[data-product-link], #cart-drawer-recommendations-container [data-product-title-link]');
    if (!productLink) return;

    const productCard = productLink.closest('[data-product-id]');
    if (!productCard) return;

    const productId = productCard.dataset.productId;
    const productHandle = productCard.dataset.productHandle;
    const productPrice = productCard.dataset.productPrice || '';
    const productName = productCard.querySelector('[data-product-title-link]')?.textContent?.trim() || '';

    // Get position in list
    const container = document.getElementById('cart-drawer-recommendations-list');
    const allCards = container ? Array.from(container.querySelectorAll('[data-product-id]')) : [];
    const position = allCards.indexOf(productCard) + 1;

    push({
      event: 'cart_drawer_recommendation_click',
      recommended_product_id: productId,
      recommended_product_handle: productHandle,
      recommended_product_name: productName,
      recommended_product_price: productPrice,
      position: position,
      recommendation_source: 'cart_drawer'
    });
  });

  // ----------------------------------------------------------
  // 17. CART DRAWER RECOMMENDATION ADD TO CART
  // ----------------------------------------------------------
  // Track when add-to-cart button clicked in cart drawer recommendations
  document.addEventListener('click', function(e) {
    const addButton = e.target.closest('#cart-drawer-recommendations-container .horizontal-product__cta .button[data-variant-id]');
    if (!addButton) return;

    const productCard = addButton.closest('[data-product-id]');
    if (!productCard) return;

    const productId = productCard.dataset.productId;
    const productHandle = productCard.dataset.productHandle;
    const productPrice = productCard.dataset.productPrice || '';
    const productName = productCard.querySelector('[data-product-title-link]')?.textContent?.trim() || '';
    const variantId = addButton.dataset.variantId;

    // Get position in list
    const container = document.getElementById('cart-drawer-recommendations-list');
    const allCards = container ? Array.from(container.querySelectorAll('[data-product-id]')) : [];
    const position = allCards.indexOf(productCard) + 1;

    push({
      event: 'cart_drawer_recommendation_add_to_cart',
      recommended_product_id: productId,
      recommended_product_handle: productHandle,
      recommended_product_name: productName,
      recommended_product_price: productPrice,
      recommended_variant_id: variantId,
      position: position,
      recommendation_source: 'cart_drawer'
    });
  });

  // ----------------------------------------------------------
  // 18. CART DRAWER RECOMMENDATION QUICK BUY OPEN
  // ----------------------------------------------------------
  document.addEventListener('click', function(e) {
    const quickBuyButton = e.target.closest('#cart-drawer-recommendations-container .horizontal-product__cta .button[aria-controls^="quick-buy-dynamic"]');
    if (!quickBuyButton) return;

    const productCard = quickBuyButton.closest('[data-product-id]');
    if (!productCard) return;

    const productId = productCard.dataset.productId;
    const productHandle = productCard.dataset.productHandle;
    const productPrice = productCard.dataset.productPrice || '';
    const productName = productCard.querySelector('[data-product-title-link]')?.textContent?.trim() || '';

    // Get position in list
    const container = document.getElementById('cart-drawer-recommendations-list');
    const allCards = container ? Array.from(container.querySelectorAll('[data-product-id]')) : [];
    const position = allCards.indexOf(productCard) + 1;

    push({
      event: 'cart_drawer_recommendation_quick_buy_open',
      recommended_product_id: productId,
      recommended_product_handle: productHandle,
      recommended_product_name: productName,
      recommended_product_price: productPrice,
      position: position,
      recommendation_source: 'cart_drawer'
    });
  });

  // ============================================================
  //  END CUSTOM EDIT: Cart Drawer Recommendations Tracking
  // ============================================================

  // ============================================================
  //  BEGIN CUSTOM EDIT: Unified Product Finder/Length Guide Tracking | Date: 2026-03-22
  //  What: Shared pf_ event API for both product finder and length guide modal
  // ============================================================
  var _pfStepViewed = {};
  var _pfStartedSources = {};

  /**
   * Unified product finder / length guide dataLayer tracking.
   * @param {string} event   - Event name (e.g. 'pf_selection_made')
   * @param {string} source  - 'finder' or 'length_guide'
   * @param {object} data    - Additional event properties
   */
  window.pfTrack = function(event, source, data) {
    push(Object.assign({ event: event, source: source }, data || {}));
  };

  /**
   * Fire pf_started once per source per page load.
   */
  window.pfTrackStarted = function(source, entryPoint) {
    if (_pfStartedSources[source]) return;
    _pfStartedSources[source] = true;
    push({ event: 'pf_started', source: source, entry_point: entryPoint || 'page' });
  };

  /**
   * Fire pf_step_viewed once per source+step per page load.
   */
  window.pfTrackStep = function(source, step, stepName, stepTotal) {
    var key = source + ':' + stepName;
    if (_pfStepViewed[key]) return;
    _pfStepViewed[key] = true;
    push({ event: 'pf_step_viewed', source: source, step: step, step_name: stepName, step_total: stepTotal });
  };
  // ============================================================
  //  END CUSTOM EDIT
  // ============================================================

  // ============================================================
  //  BEGIN CUSTOM EDIT: Collection section navigation events | Date: 2026-09-16
  //  What: Push page_view + collection_swap when the form grid swaps collections without a page load
  //  Why: GTM page-view tags fire on DOM Ready only, so section-rendered navigations were invisible
  // ============================================================
  var _collectionNavigationStartedAt = 0;

  function _collectionHandleFromUrl(url) {
    try {
      var match = new URL(url, window.location.origin).pathname.match(/\/collections\/([^\/?#]+)/);
      return match ? match[1] : null;
    } catch (_) { return null; }
  }

  function _collectionNavigationNow() {
    return window.performance && typeof performance.now === 'function' ? performance.now() : Date.now();
  }

  document.addEventListener('collection:navigation:start', function () {
    _collectionNavigationStartedAt = _collectionNavigationNow();
  });

  document.addEventListener('collection:navigation:complete', function (e) {
    var d = e.detail || {};
    if (d.success !== true) return;
    var url;
    try { url = new URL(d.url, window.location.origin); } catch (_) { url = null; }
    var collection = d.collection || {};
    var duration = _collectionNavigationStartedAt ? Math.round(_collectionNavigationNow() - _collectionNavigationStartedAt) : null;
    _collectionNavigationStartedAt = 0;

    push({
      event: 'page_view',
      page_location: url ? url.href : d.url,
      page_path: url ? url.pathname : d.url,
      page_title: document.title,
      navigation_type: d.historyNavigation ? 'collection_section_history' : 'collection_section_navigation',
      user_data: getLastUserData()
    });

    push({
      event: 'collection_swap',
      from_collection: _collectionHandleFromUrl(d.fromUrl),
      to_collection: collection.handle || _collectionHandleFromUrl(d.url),
      collection_id: collection.id || null,
      collection_title: collection.title || null,
      products_count: typeof collection.productsCount === 'number' ? collection.productsCount : null,
      duration_ms: duration,
      navigation_type: d.historyNavigation ? 'history' : 'link',
      source: 'editorial_banner_forms_grid',
      user_data: getLastUserData()
    });
  });
  // ============================================================
  //  END CUSTOM EDIT
  // ============================================================

})();
// END CUSTOM EDIT
